import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    quote:
      "vonmal turned our idea into a live AI product in a single week. The speed felt unreal and the quality was production-grade.",
    name: "Founder",
    role: "HealthTech Startup",
    accent: "cyan",
  },
  {
    quote:
      "They shipped our marketing site in a day — pixel-perfect and blazing fast. Easiest launch we've ever had.",
    name: "Marketing Lead",
    role: "SaaS Company",
    accent: "yellow",
  },
  {
    quote:
      "The AI agent they built now handles our research and support workflows end-to-end. Lean pricing, huge impact.",
    name: "Operations Head",
    role: "Growth Agency",
    accent: "magenta",
  },
];

const accentMap = {
  cyan: "text-neon-cyan",
  yellow: "text-neon-yellow",
  magenta: "text-neon-magenta",
};

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 relative border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-12 max-w-2xl">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-neon-cyan mb-3">// what clients say</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter">
            Builders who <span className="text-neon-cyan">shipped with us.</span>
          </h2>
        </div>

        <div className="grid gap-5 md:grid-cols-3">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="glow-border rounded-2xl border border-neon-cyan/15 bg-surface p-7 flex flex-col"
            >
              <Quote size={28} className={accentMap[t.accent]} />
              <p className="mt-4 text-white/75 leading-relaxed flex-1">"{t.quote}"</p>
              <div className="mt-6 flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={14} className="fill-neon-yellow text-neon-yellow" />
                ))}
              </div>
              <div>
                <div className="font-semibold text-sm">{t.name}</div>
                <div className="text-xs text-white/45">{t.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
